import { supabase } from './supabase';
import { generateUUID } from './uuid';

// Upload a base64 JPEG data URL to Supabase Storage.
// Returns the public URL string, or null on failure (non-fatal).
export async function uploadScreenshot(dataUrl) {
  try {
    const base64 = dataUrl.split(',')[1];
    const bytes  = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const blob   = new Blob([bytes], { type: 'image/jpeg' });
    const path   = `${generateUUID()}.jpg`;

    const { error } = await supabase.storage
      .from('support-screenshots')
      .upload(path, blob, { contentType: 'image/jpeg', upsert: false });

    if (error) return null;

    const { data } = supabase.storage
      .from('support-screenshots')
      .getPublicUrl(path);

    return data?.publicUrl || null;
  } catch {
    return null;
  }
}

// Insert a bug report. Throws on database error.
export async function submitBugReport({
  description,
  route,
  screenshot_url,
  device_info,
  app_version,
  user_id,
  district_id,
}) {
  const { error } = await supabase.from('bug_reports').insert({
    id:             generateUUID(),
    description,
    route:          route          || null,
    screenshot_url: screenshot_url || null,
    device_info:    device_info    || null,
    app_version:    app_version    || null,
    user_id:        user_id        || null,
    district_id:    district_id    || null,
    status:         'open',
    created_at:     new Date().toISOString(),
  });

  if (error) throw error;
}

// Returns open bug reports for admin view, joined with reporter profile.
export async function getOpenBugReports(limit = 50) {
  const { data, error } = await supabase
    .from('bug_reports')
    .select('*, reporter:profiles ( full_name, email )')
    .eq('status', 'open')
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) throw error;
  return data || [];
}

// Returns count of open bug reports (lightweight — uses HEAD request).
export async function getOpenReportsCount() {
  const { count, error } = await supabase
    .from('bug_reports')
    .select('id', { count: 'exact', head: true })
    .eq('status', 'open');

  if (error) return 0;
  return count || 0;
}

// Mark a report as resolved (admin only).
export async function resolveBugReport(id) {
  const { error } = await supabase
    .from('bug_reports')
    .update({ status: 'resolved' })
    .eq('id', id);

  if (error) throw error;
}
